import StepsByWeekGraph from "../features/statistics/components/step-by-week-graph";


export default function StepByWeekReportsView() {
  return (
    <>
      <StepsByWeekGraph/>
    </>
  )
}